"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Notification = _interopRequireDefault(require("./Notification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const WarningNotification = _ref => {
  let {
    colorClassName,
    iconName,
    status,
    children,
    footer
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Notification.default, {
    colorClassName: colorClassName,
    iconName: iconName,
    status: status,
    footer: footer
  }, children);
};
WarningNotification.propTypes = {
  colorClassName: _propTypes.default.string,
  iconName: _propTypes.default.string,
  status: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  footer: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
WarningNotification.defaultProps = {
  colorClassName: 'has-text-warning',
  iconName: 'warning_amber',
  status: 'Warning'
};
var _default = exports.default = WarningNotification;
//# sourceMappingURL=WarningNotification.js.map